import React, { useState, useEffect, useRef } from 'react';
import './LiveChat.css';
import { MessageCircle, X, Phone, Mail } from 'lucide-react';

const LiveChat = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const chatRef = useRef(null); // reference to popup

  const toggleChat = () => {
    setIsOpen(!isOpen);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Email:', email);
    console.log('Message:', message);
    alert('Message Sent!');
    setEmail('');
    setMessage('');
    setIsOpen(false);
  };

  // Detect click outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (chatRef.current && !chatRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  return (
    <>
      <div
        ref={chatRef}
        className={`live-chat-popup ${isOpen ? 'live-chat-open' : ''}`}
      >
        <div className="live-chat-header">
          <span className="live-chat-title">Get In Touch</span>
          <button className="live-chat-close-btn" onClick={toggleChat}>
            <X size={20} />
          </button>
        </div>

        {/* Top Buttons */}
        <div className="live-chat-top-actions">
          <a href="tel:+918709364253" className="live-chat-action-btn">
            <Phone size={18} /> Call Us
          </a>
          <a
            href="https://wa.me/918709364253"
            target="_blank"
            rel="noopener noreferrer"
            className="live-chat-action-btn"
          >
            <MessageCircle size={18} /> Chat Now
          </a>
        </div>

        {/* Bottom Form */}
        <form className="live-chat-form" onSubmit={handleSubmit}>
          <div className="live-chat-input-group">
            <Mail size={16} className="live-chat-input-icon" />
            <input
              type="email"
              placeholder="Your Email"
              value={email}
              required
              onChange={(e) => setEmail(e.target.value)}
              className="live-chat-input"
            />
          </div>
          <textarea
            placeholder="Type your message..."
            value={message}
            required
            onChange={(e) => setMessage(e.target.value)}
            className="live-chat-textarea"
          ></textarea>
          <button type="submit" className="live-chat-submit-btn">
            Submit
          </button>
        </form>
      </div>

      {/* Floating Chat Toggle Button */}
      <button className="live-chat-toggle-btn" onClick={toggleChat}>
        <MessageCircle size={22} />
      </button>
    </>
  );
};

export default LiveChat;
